export default {"src":"/_next/static/media/amex.6d474f5c.svg","height":24,"width":35,"blurWidth":0,"blurHeight":0};